// @flow
import React, { Component } from 'react';
//types
import { type Currencies } from '../../../utilities/types';
import { connect } from 'react-redux';
import {
  loadCommissionPaidIndex,
  changePage,
  toggleCalendarFilter,
  setPerPageFilter,
  orderByAmount
} from './reducer';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import CrudTableIndex from '../../../modules/CrudTable/CrudTableIndex';
export type CommissionPaid = {
  id: number,
  iso: string,
  amount: number,
  created_at: string,
  status: string,
  currency: string
};

export type Filters = {
  perPageFilter: string,
  setPerPageFilter: () => void,
  availableFilters: { status: Array<string> }
};

type Props = {
  commissionPaidIndex: CommissionPaid[],
  loadCommissionPaidIndex: (params: {}) => void,
  failedLoad: boolean,
  loading: boolean,
  currencies: Currencies,

  //Paginator
  paginatorTotal: number,
  currentPage: number,
  changePage: ({
    id: number | string,
    page: number,
    perPage: number
  }) => void,
  previouslyVisited: number[],
  // ...$Exact<PaginatorProps>,

  orderByAmount: () => void,
  orderByState: number
} & Filters;

class CommissionPaidIndex extends Component<Props> {
  render() {
    return (
      <CrudTableIndex
        // Table
        TableHeader={
          <TableHeader
            orderBy={{ amount: this.props.orderByAmount }}
            orderState={{ amount: this.props.orderByState }}
          />
        }
        tableData={this.props.commissionPaidIndex}
        loadTableIndexData={this.props.loadCommissionPaidIndex}
        loading={this.props.loading}
        failedLoad={this.props.failedLoad}
        currencies={this.props.currencies}
        // $FlowFixMe props are passed in by cloneElement
        TableRow={<TableRow />}
        tableBodyOptions={{
          text: 'No Commissions Paid',
          model: 'Commission Payouts',
          img: 'withdraw'
        }}
        // Paginator
        paginatorTotal={this.props.paginatorTotal}
        currentPage={this.props.currentPage}
        changePage={this.props.changePage}
        previouslyVisited={this.props.previouslyVisited}
        // Paginator Filter
        currentPerPage={this.props.perPageFilter}
        setPerPage={this.props.setPerPageFilter}
        perPageOptions={[10, 25, 50]}
      />
    );
  }
}

const mapStateToProps = state => ({
  commissionPaidIndex:
    state.commissionPayouts.commissionPaid.index.commission_payouts,
  loading: state.commissionPayouts.commissionPaid.index.loading,
  failedLoad: state.commissionPayouts.commissionPaid.index.failedLoad,
  currentPage: state.commissionPayouts.commissionPaid.index.currentPage,
  paginatorTotal: state.commissionPayouts.commissionPaid.index.paginatorTotal,
  previouslyVisited:
    state.commissionPayouts.commissionPaid.index.previouslyVisited,
  currencies: state.global.currencies,
  perPageFilter: state.commissionPayouts.commissionPaid.index.perPageFilter,

  orderByState: state.commissionPayouts.commissionPaid.index.orderByState
});

const mapDispatchToProps = {
  loadCommissionPaidIndex,
  changePage,
  toggleCalendarFilter,
  setPerPageFilter,
  orderByAmount
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommissionPaidIndex);
